import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap";
import { createSelector } from "reselect";
import { useSelector } from "react-redux";

//import images
import avatar1 from "../../assets/images/users/avatar-1.jpg";
import dummyImg from "../../assets/images/users/user-dummy-img.jpg";
import ImageWithFallback from "./ImageWithFallback";

const ProfileDropdown = () => {
  const { user } = useSelector((state) => ({
    user: state.Profile.user,
  }));

  const handleSignout = () => {
    localStorage.removeItem("authUser");
  };

  const [userName, setUserName] = useState("");
  const [company, setCompany] = useState("");
  const [image, setImage] = useState(dummyImg);

  useEffect(() => {
    if (localStorage.getItem("authUser")) {
      const obj = JSON.parse(localStorage.getItem("authUser"));

      setUserName(`${obj.last_name.charAt(0)}.${obj.first_name}`);
      setCompany(obj.company);
      setImage(obj.image_url || dummyImg);
    }
  }, [userName, user]);

  // const profiledropdownData = createSelector(
  //     (state) => state.Profile,
  //     (state) => ({
  //         user: state.user
  //     })
  //   );
  // Inside your component
  //const {user} = useSelector(profiledropdownData);

  //const [userName, setUserName] = useState("Admin");

  //   useEffect(() => {
  //     if (sessionStorage.getItem("authUser")) {
  //       const obj = JSON.parse(sessionStorage.getItem("authUser"));
  //       setUserName(
  //         process.env.REACT_APP_DEFAULTAUTH === "fake"
  //           ? obj.username === undefined
  //             ? user.first_name
  //               ? user.first_name
  //               : obj.data.first_name
  //             : "Admin" || "Admin"
  //           : process.env.REACT_APP_DEFAULTAUTH === "firebase"
  //           ? obj.email && obj.email
  //           : "Admin"
  //       );
  //     }
  //   }, [userName, user]);

  //Dropdown Toggle
  const [isProfileDropdown, setIsProfileDropdown] = useState(false);
  const toggleProfileDropdown = () => {
    setIsProfileDropdown(!isProfileDropdown);
  };
  return (
    <React.Fragment>
      <Dropdown
        isOpen={isProfileDropdown}
        toggle={toggleProfileDropdown}
        className="ms-sm-3 header-item topbar-user"
      >
        <DropdownToggle tag="button" type="button" className="btn">
          <span className="d-flex align-items-center">
            <ImageWithFallback
              className="rounded-circle header-profile-user"
              src={image}
              fallbackSrc={dummyImg}
              alt="Header Avatar"
            />
            <span className="text-start ms-xl-2">
              <span className="d-none d-xl-inline-block ms-1 fw-medium user-name-text">
                {userName}
              </span>
              <span className="d-none d-xl-block ms-1 fs-12 text-muted user-name-sub-text">
                {company}
              </span>
            </span>
          </span>
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-end">
          <DropdownItem className="p-0">
            <Link to="/user-settings" className="dropdown-item">
              <i className="ri-lock-password-line text-muted fs-16 align-middle me-1"></i>{" "}
              <span className="align-middle">Тохиргоо</span>
            </Link>
          </DropdownItem>
          <DropdownItem className="p-0">
            <Link to="/logout" className="dropdown-item">
              <i className="mdi mdi-logout text-muted fs-16 align-middle me-1"></i>{" "}
              <span className="align-middle" data-key="t-logout">
                Гарах
              </span>
            </Link>
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  );
};

export default ProfileDropdown;
